export const getCurrentLanguage = (fileBased: boolean = false) => {
  // this regex matches all paths that end with -fr.html, -fr.html/, fr or -fr/
  if (fileBased) {
    const regex = /\/.*-fr(\.html)?\/?$/;
    const path = window.location.pathname;
    return regex.test(path) ? "fr" : "nl";
  }

  // Domain based detection
  const regex = /.*comparateur\.be\/?$/;
  const domain = window.location.hostname;
  return regex.test(domain) ? "fr" : "nl";
};
